<template>
  <div
    class="canvasManagement"
    :style="{ overflow: animation ? 'hidden' : '' }"
  >
    <div class="header">
      <div class="header-tab">
        <div
          class="tab-item"
          :class="activeIndex === 1 ? 'active' : ''"
          @click="switchCanvas(1)"
        >
          <span>我的画布</span>
          <div class="line"></div>
        </div>
        <div
          class="tab-item"
          :class="activeIndex === 2 ? 'active' : ''"
          @click="switchCanvas(2)"
        >
          <span>我的分享</span>
          <div class="line"></div>
        </div>
      </div>
      <el-input
        placeholder="按画布名称搜索"
        clearable
        prefix-icon="el-icon-search"
        class="searchInput"
        @input="searchCanvas"
        v-model="queryName"
      >
      </el-input>
    </div>

    <div
      class="main"
      v-show="activeIndex === 1"
    >
      <transition
        name="el-fade-in-linear"
        @before-enter="animation = true"
        @after-leave="animation = false"
      >
        <div
          class="content"
          v-show="activeIndex === 1"
        >
          <div
            class="box first"
            @click="addCanvas"
            v-if="permissionLevel >= PermissionLevel.COMPILER"
          >
            <svg
              width="4.8rem"
              height="4.8rem"
              fill="rgba(255, 255, 255, 0.3)"
              aria-hidden="true"
            >
              <use xlink:href="#icon-close-bold"></use>
            </svg>
          </div>
          <div
            class="box"
            v-for="(item, index) in canvasList"
            :key="index"
          >
            <div class="earthBox">
              <img
                :src="item.cover"
                alt="img"
                v-if="item.cover"
              />
              <img
                src="@/assets/images/Default-picture.png"
                alt="img"
                v-else
              />
              <div class="shade">
                <el-button
                  type="primary"
                  @click="preview(item)"
                >预览</el-button>
                <el-button
                  type="primary"
                  @click="openEdit(item)"
                  :disabled="permissionLevel <= PermissionLevel.LOOKER"
                >编辑</el-button>
              </div>
            </div>
            <div class="center">
              <div class="title">
                <el-tooltip
                  :content="item.name"
                  placement="top-start"
                  effect="light"
                  :open-delay="1000"
                  v-if="item.name.length > 11"
                >
                  <span><img
                      src="@/assets/images/computer.png"
                      alt="img"
                    />{{
                      item.name
                    }}</span>
                </el-tooltip>
                <span v-else><img
                    src="@/assets/images/computer.png"
                    alt="img"
                  />{{
                    item.name
                  }}</span>
              </div>
            </div>
            <div class="bottom">
              <div class="time">
                <i class="el-icon-time"></i>{{ new Date(item.createdTime).format('yyyy/MM/dd hh:mm') }}
              </div>
              <span class="icons">
                <el-tooltip
                  content="分享"
                  placement="top"
                  effect="light"
                  :open-delay="1000"
                >
                  <Icon
                    name="icon-share2"
                    @click="openShareDialog(item, false)"
                  ></Icon>
                </el-tooltip>
                <el-tooltip
                  content="复制"
                  placement="top"
                  effect="light"
                  :open-delay="1000"
                >
                  <Icon
                    name="icon-copy-b"
                    @click="copyCanvas(item)"
                    :disabled="permissionLevel <= PermissionLevel.LOOKER"
                  ></Icon>
                </el-tooltip>
                <el-tooltip
                  content="删除"
                  placement="top"
                  effect="light"
                  :open-delay="1000"
                >
                  <Icon
                    name="icon-ashbin"
                    @click="deleteCanvas(item)"
                    :disabled="permissionLevel <= PermissionLevel.LOOKER"
                  ></Icon>
                </el-tooltip>
              </span>
            </div>
          </div>
        </div>
      </transition>
      <div
        class="empty2"
        v-if="!canvasList.length"
      >
        <Empty2></Empty2>
      </div>
    </div>

    <div
      class="main"
      v-show="activeIndex === 2"
    >
      <transition
        name="el-fade-in-linear"
        @before-enter="animation = true"
        @after-leave="animation = false"
      >
        <div
          class="content"
          v-show="activeIndex === 2"
        >
          <div
            class="box"
            v-for="(item, index) in shareList"
            :key="index"
          >
            <div class="earthBox">
              <img
                :src="item.cover"
                alt="img"
                v-if="item.cover"
              />
              <img
                src="@/assets/images/Default-picture.png"
                alt="img"
                v-else
              />
              <div class="shade">
                <el-button
                  type="primary"
                  @click="openShareUrl(item)"
                >打开分享</el-button>
              </div>
            </div>
            <div class="center">
              <div class="title">
                <el-tooltip
                  :content="item.name"
                  placement="top-start"
                  effect="light"
                  :open-delay="1000"
                  v-if="item.name.length > 11"
                >
                  <span><img
                      src="@/assets/images/computer.png"
                      alt="img"
                    />{{
                      item.name
                    }}</span>
                </el-tooltip>
                <span v-else><img
                    src="@/assets/images/computer.png"
                    alt="img"
                  />{{
                    item.name
                  }}</span>
              </div>
            </div>
            <div class="bottom">
              <div class="time">
                <i class="el-icon-time"></i>{{ new Date(item.createdTime).format('yyyy/MM/dd hh:mm') }}
              </div>
              <span class="icons">
                <el-tooltip
                  content="分享"
                  placement="top"
                  effect="light"
                  :open-delay="1000"
                >
                  <Icon
                    name="icon-share2"
                    @click="openShareDialog(item, true)"
                  ></Icon>
                </el-tooltip>
              </span>
            </div>
          </div>
        </div>
      </transition>
      <div
        class="empty2"
        v-if="!shareList.length"
      >
        <Empty2></Empty2>
      </div>
    </div>

    <CanvasShareDialog
      ref="shareDialog"
      @refresh="updateCanvasList"
    ></CanvasShareDialog>
  </div>
</template>

<script>
import {
  getCanvasList,
  addCanvas,
  delCanvas,
  copyCanvas,
  getCanvasDetails,
  getShareCanvasList,
  getDataSourceSchemas
} from '@/api/canvasManagement'
import * as api2 from '@/api/mapManagement'
import { mapGetters } from 'vuex'
import CanvasShareDialog from './components/CanvasShareDialog'
import { PermissionLevel } from '@/configs/constants'

export default {
  props: {},
  components: {
    CanvasShareDialog
  },
  data () {
    return {
      animation: false,
      activeIndex: 1,
      keywords: '',
      areaOptions: [],
      queryParams: {
        name: '',
        pageSize: 10000,
        pageNumber: 1
      },
      queryParamsShare: {
        name: '',
        pageSize: 10000,
        pageNumber: 1
      },
      canvasList: [],
      shareList: [],
      timer: null,
      // 编辑器引用
      editor: [],
      // 渲染器引用
      renderer: [],
      PermissionLevel,
      queryName: ''
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'permissionLevel'])
  },
  mounted () {
    this.getShareCanvasList()
    this.getCanvasList()
    // canvas:refresh
    window.addEventListener('message', this.receiveMessage, false)
  },
  destroyed () {
    window.removeEventListener('message', this.receiveMessage)
    this.timer && clearTimeout(this.timer)
  },
  methods: {
    // 我的画布 我的分享 菜单切换
    switchCanvas (index) {
      this.activeIndex = index
      this.queryName = ''
      this.queryParams.name = ''
      this.queryParamsShare.name = ''
      index === 1 ? this.getCanvasList() : this.getShareCanvasList()
    },
    receiveMessage (event) {
      // 我们能信任信息来源吗？
      if (event.origin !== window.location.origin) {
        return
      }
      if (/^canvas:refresh$/i.test(event.data)) {
        // 刷新画布数据
        this.getCanvasList()
      }
    },
    // 新增画布
    async addCanvas () {
      try {
        await addCanvas()
        this.getCanvasList()
      } catch (e) {
        if (e.response && e.response.status === 4000) {
          this.$Delete({
            confirm: () => {
              this.$router.push('/payManagement')
            },
            message: '当前画布数量已满, 是否立即升级团队'
          })
        }
      }
    },
    async getCanvasList () {
      const res = await getCanvasList(this.queryParams)
      if (res.code === 200) {
        this.canvasList = res.data.records
      }
    },
    async getShareCanvasList () {
      const res = await getShareCanvasList(this.queryParamsShare)
      if (res.code === 200) {
        this.shareList = res.data.records
      }
    },
    // 按名字搜索画布或分享
    searchCanvas () {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (this.activeIndex === 1) {
          this.queryParams.name = this.queryName
          this.getCanvasList(this.queryParams)
        } else {
          this.queryParamsShare.name = this.queryName
          this.getShareCanvasList(this.queryParamsShare)
        }
      }, 500)
    },
    // 预览
    async preview (item) {
      // const { renderer } = this
      // const KEY = `PREVIEW_${item.id}`
      // // 判断是否已经打开了预览窗体
      // if (renderer.some(p => p.key === KEY)) {
      //   this.$message.error(`禁止重复打开【${item.name}】`)
      //   return
      // }
      const { data: config } = await getCanvasDetails(item.id)
      if (
        !config.jsonForDetail ||
        config.jsonForDetail === {} ||
        !config.jsonForDetail.id
      ) {
        this.$Message('warning', '当前画布无数据，请先编辑画布')
        return
      }
      const previewCache = '_preview_cache'
      localStorage.removeItem(previewCache)

      if (this.previewWin) {
        this.previewWin.close()
        this.previewWin = undefined
      }
      const win = window.open('/dveditor/renderer.html?t=' + Date.now())
      this.previewWin = win

      win.magic = {
        onPageElUpdate () {},
        onRuntimeReady (runtime) {
          win.document.title = `预览 ${item.name}`
          // win.onunload = function () {
          //   _.pullAllBy(renderer, [{ key: KEY }], 'key')
          // }
          runtime.updateRootConfig(config.jsonForDetail || {})
        }
      }
      // renderer.push({
      //   key: KEY
      // })
    },
    // 编辑
    async openEdit (item) {
      const { data: config } = await getCanvasDetails(item.id, item)
      const dataSourceSchemas = await getDataSourceSchemas()
      console.log(dataSourceSchemas)
      const { data: data2 } = await api2.getMapPages({
        pageSize: 10000,
        pageNumber: 1
      })
      // if (this.editWin) {
      //   this.editWin.close()
      //   this.editWin = undefined
      // }
      const win = window.open('/dveditor/editor.html?id=' + item.id)
      // this.editWin = win
      win.magic = {
        onPageElUpdate () {},
        onRuntimeReady (runtime) {
          win.document.title = `编辑 ${item.name}`
          /**
           *
           * {
      id: 'app_1',
      type: NodeType.ROOT,
      name: '未命名画布',
      style: {
        mode: 0,
        width: 1920,
        height: 1080,
      },
      items: [],
      dataSourceSchemas: [],
    }
           */
          const temp = {
            id: 'app_1',
            type: 'app',
            name: item.name,
            style: {
              mode: 0,
              width: 1920,
              height: 1080
            },
            items: [],
            ...(config.jsonForDetail || {}),
            maps: data2.records.map((p) => ({
              id: p.id,
              name: p.name
            }))
          }
          console.log('xxxxxxxxxx2', temp)
          runtime.updateRootConfig(temp)
          runtime.updateDataSource(dataSourceSchemas)
        }
        // save: async (config, name) => {
        //   // todo
        //   // console.log(item, config, name)
        //   const params = {
        //     'cover': config.snapshot ? config.snapshot : '',
        //     'id': item.id,
        //     'jsonForDetail': config,
        //     'name': name,
        //     'mapId': config.mapId
        //   }
        //   await saveCanvas(params)
        //   await this.getCanvasList()
        // }
      }
    },
    async copyCanvas (item) {
      try {
        await copyCanvas(item.id)
        this.getCanvasList()
      } catch (e) {
        if (e.response && e.response.status === 4000) {
          this.$Delete({
            confirm: () => {
              this.$router.push('/payManagement')
            },
            message: '当前画布数量已满, 是否立即升级团队'
          })
        }
      }
    },
    async deleteCanvas (item) {
      // 判断是否已经打开了预览窗体
      if (!this.renderer.length && !this.editor.length) {
        this.$Delete({
          message: '你确定删除该数据吗？',
          confirm: async () => {
            const res = await delCanvas(item.id)
            this.$Message('success', res.msg)
            this.getShareCanvasList()
            this.getCanvasList()
          },
          cancel: () => {}
        })
      } else {
        this.$Message('error', '您正在预览/编辑此画布，请先关闭页面!')
      }
    },
    // 更新画布列表
    updateCanvasList () {
      this.getShareCanvasList()
      this.getCanvasList()
    },
    // 打开分享界面
    openShareDialog (item, isShare) {
      this.$refs.shareDialog.open(
        isShare ? item.canvaId : item.id,
        item.enableShare,
        item.noncestr
      )
    },
    // 打开分享界面
    openShareUrl (item) {
      const baseUrl = '/canvasShare'
      window.open(`${window.location.origin}${baseUrl}/${item.noncestr}`)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.canvasManagement {
  .searchInput {
    width: 397px;
    height: 40px;
    .el-input__inner {
      height: 40px;
      border-radius: 20px;
      width: 397px;
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
<style lang="scss" scoped>
.canvasManagement {
  background-color: #18191a;
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 30px 170px 30px 170px;
  overflow-y: auto;
  position: relative;
  .header {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    .header-tab {
      display: flex;
      .tab-item {
        margin-right: 40px;
        cursor: pointer;
        span {
          font-size: 20px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #ffffff;
          opacity: 0.4;
        }
        .line {
          width: 40px;
          height: 4px;
          background: #00a4f0;
          border-radius: 2px;
          margin: 4px auto;
          opacity: 0;
        }
        &.active {
          span {
            opacity: 1;
          }
          .line {
            opacity: 1;
          }
        }
      }
    }
  }
  .main {
    width: 105%;
    height: calc(100% - 70px);
    /*overflow-y: auto;*/
    text-align: left;
    .content {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      .box {
        display: inline-block;
        width: 300px;
        height: 240px;
        background: #272829;
        box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        margin-right: 20px;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 8px;
        position: relative;
        &.first {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          > svg {
            width: 48px;
            transform: rotate(45deg);
          }
        }
        .earthBox {
          width: 284px;
          height: 160px;
          border-radius: 8px;
          margin: 0 auto;
          background: #000000;
          margin-bottom: 10px;
          position: relative;
          overflow: hidden;
          ::selection {
            background: rgba(24, 144, 255, 0) !important;
          }
          > img {
            width: 100%;
          }
          .shade {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: all 0.3s;
            border-radius: 8px;
            position: absolute;
            z-index: 100;
            top: 0;
            > button {
              margin-right: 10px;
            }
            &:hover {
              opacity: 1;
              background: rgba(0, 0, 0, 0.6);
            }
          }
        }
        .center {
          .title {
            padding-left: 6px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            > span:first-child {
              font-size: 16px;
              font-family: Source Han Sans SC;
              font-weight: 400;
              color: #ffffff;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 190px;
              > img {
                margin-right: 8px;
              }
            }
            > span:last-child {
              font-size: 16px;
              font-family: Source Han Sans SC;
              font-weight: 400;
              color: white;
            }
          }
        }
        .bottom {
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #999999;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .time {
            padding-left: 6px;
            box-sizing: border-box;
            font-size: 12px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #999999;
            i {
              margin-right: 8px;
            }
          }
          .icons {
            display: flex;
            // width: 100px;
            justify-content: space-between;
            svg {
              color: #999999;
            }
          }
        }
      }
    }
  }
  .empty2 {
    position: absolute;
    top: 30%;
    left: 0;
    right: 0;
  }
}
</style>
